import PropTypes from 'prop-types'
import ContextMenuComponent from '../../../context-menu'
import {
  contextMenuAlignOptions,
  contextMenuArrowAlignmentOptions
} from '../../../context-menu/constants'
import {
  NotificationMenuLabelContainer,
  NotificationMenuLabel,
  NotificationsContainer,
  NotificationListContainer
} from '../../styled-components'
import NotificationIcon from './components/notification-icon'
import NotificatationFooter from './components/notification-footer'
import { FormattedMessage } from 'react-intl'

import ListItemComponent from '../../../../molecules/list-items'
import { listItemListViewVariantOptions } from '../../../../molecules/list-items/constants'
import NotificationList from './components/notification-list'
import { useOnInView } from 'react-intersection-observer'
import QuickSelectComponent from '../quick-select/index'
import { useRef, useState, useEffect, useCallback } from 'react'

const NotificationMenu = ({
  notificationData,
  handleSelectEmailNotification,
  defaultSelectedValue,
  hasUnreadNotifications,
  onBottomReached,
  isFetchingNextPage,
  onClickNotification,
  onCloseCallback,
  isLoading
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const wasOpenRef = useRef(false)
  const notificationListRef = useRef(null)
  const onBottomReachedRef = useRef(onBottomReached)

  useEffect(() => {
    onBottomReachedRef.current = onBottomReached
  }, [onBottomReached])

  const bottomReachedRef = useOnInView(
    useCallback((inView) => {
      if (inView) {
        onBottomReachedRef.current?.()
      }
    }, []),
    {
      root: notificationListRef.current,
      rootMargin: '10px',
      skip: !isOpen
    }
  )

  // on close
  useEffect(() => {
    if (wasOpenRef.current && !isOpen) {
      onCloseCallback?.()
    }
    wasOpenRef.current = isOpen
  }, [isOpen, onCloseCallback])

  return (
    <ContextMenuComponent.Root isOpen={isOpen} setIsOpen={setIsOpen}>
      <ContextMenuComponent.Trigger>
        <NotificationIcon hasUnreadNotifications={hasUnreadNotifications} />
      </ContextMenuComponent.Trigger>
      <ContextMenuComponent.List
        align={contextMenuAlignOptions.START}
        width={'420px'}
        maxHeight={'auto'}
        height={'auto'}
        arrow={true}
        arrowAlignment={contextMenuArrowAlignmentOptions.END}
        sideYOffSet={4}
        sideXOffset={10}
      >
        <NotificationsContainer>
          <NotificationMenuLabelContainer top>
            <NotificationMenuLabel>
              <FormattedMessage id="notification_title" />
            </NotificationMenuLabel>
          </NotificationMenuLabelContainer>

          <ContextMenuComponent.Divider />

          <NotificationListContainer ref={notificationListRef}>
            <ListItemComponent.Root
              listViewType={listItemListViewVariantOptions.SEPARATE}
              style={{ gap: '0' }}
            >
              <NotificationList
                isLoading={isLoading}
                notificationData={notificationData}
                onClickNotification={onClickNotification}
                onCloseCallback={onCloseCallback}
              />
            </ListItemComponent.Root>

            {isFetchingNextPage && <QuickSelectComponent.LoadingItem />}

            <div
              ref={bottomReachedRef}
              style={{
                height: '1px'
              }}
            />
          </NotificationListContainer>

          <NotificatationFooter
            handleSelectEmailNotification={handleSelectEmailNotification}
            defaultSelectedValue={defaultSelectedValue}
          />
        </NotificationsContainer>
      </ContextMenuComponent.List>
    </ContextMenuComponent.Root>
  )
}

NotificationMenu.propTypes = {
  notificationData: PropTypes.array,
  handleSelectEmailNotification: PropTypes.func,
  defaultSelectedValue: PropTypes.array
}

export default NotificationMenu
